import {
  FieldOkConfig,
  FieldOkListViewComponent,
  FieldOkMultiselectListViewComponent,
  QueryFieldOkListViewComponent,
} from '@softline/dynamic';
import { PickerltypListView } from './list-view/pickerltyp.list-view';

export const pickerltypFieldOk: FieldOkConfig = {
  name: 'pickerltyp',
  type: 'default',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{id}} - {{pickerltyp}}',
  autoQuery: true,
  views: [
    {
      name: 'list',
      component: FieldOkListViewComponent,
      title: 'Auswahl',
      config: {
        component: PickerltypListView,
        sort: {
          properties: [{ property: 'objekt', title: 'Objekt' }],
        },
      },
    },
  ],
};
export const pickerltypMultiselectFieldOk: FieldOkConfig = {
  name: 'pickerltyp',
  type: 'multi',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{id}} - {{pickerltyp}}',
  autoQuery: true,
  views: [
    {
      name: 'list',
      component: FieldOkMultiselectListViewComponent,
      title: 'Auswahl',
      config: {
        component: PickerltypListView,
        sort: {
          properties: [{ property: 'objekt', title: 'Objekt' }],
        },
      },
    },
  ],
};

export const pickerltypQueryFieldOk: FieldOkConfig = {
  name: 'pickerltyp',
  type: 'query',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{id}} - {{pickerltyp}}',
  autoQuery: true,
  views: [
    {
      name: 'list',
      component: QueryFieldOkListViewComponent,
      title: 'Auswahl',
      config: {
        component: PickerltypListView,
        sort: {
          properties: [{ property: 'objekt', title: 'Objekt' }],
        },
      },
    },
  ],
};
